import AntdLayout from 'antd/lib/layout'
// Components
import Header from './Header'
// interfaces
import { BaseInterface } from 'Interfaces'
import SideMenu from './SideMenu'
import Styles from './Styles.module.scss'

const { REACT_APP_VERSION } = process.env

const { Content, Header: AntdHeader } = AntdLayout

const Layout: React.FC<BaseInterface> = ({ children }) => {
  return (
    <AntdLayout
      style={{ height: '100vh', minWidth: '1024px' }}
      className={Styles.globalStyles}
    >
      <SideMenu />
      <AntdLayout>
        <AntdHeader style={{ height: '3rem' }}>
          <Header />
        </AntdHeader>
        <Content>{children}</Content>
        <span className="versionLabel">v {REACT_APP_VERSION}</span>
      </AntdLayout>
    </AntdLayout>
  )
}

export default Layout
